import React from 'react';
import { BrowserRouter, Switch, Route, Link, NavLink } from "react-router-dom"


class Nav extends React.Component {

	render() {
		return (
			<nav className="navbar navbar-expand-lg navbar-light">
				<div className="">
					<Link to="/" className="navbar-brand font-weight-500 text-logo">📩 Social Exporter</Link>
				</div>
			</nav>
		)
	}

}

export default Nav
